"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _styles = require("@material-ui/styles");

// Chip related
// Custom outlined version
var outLinedCustomChip = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderColor: function borderColor(props) {
        return "".concat(theme.palette[props.styleType][props.styleVariant]);
      },
      color: function color(props) {
        return "".concat(theme.palette[props.styleType][props.styleText]);
      },
      '& > div': {
        backgroundColor: function backgroundColor(props) {
          return "".concat(theme.palette[props.styleType][props.styleVariant]);
        },
        color: function color(props) {
          return "".concat(theme.palette[props.styleType][props.styleText]);
        }
      },
      '&:hover, &:focus': {
        background: 'none !important',
        opacity: '0.8'
      }
    }
  };
}); // Custom filled version

var filledCustomChip = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: function backgroundColor(props) {
        return "".concat(theme.palette[props.styleType][props.styleVariant]);
      },
      color: function color(props) {
        return "".concat(theme.palette[props.styleType][props.styleText]);
      },
      '& > div': {
        backgroundColor: function backgroundColor(props) {
          return "".concat(theme.palette[props.styleType][props.styleVariant]);
        },
        color: function color(props) {
          return "".concat(theme.palette[props.styleType][props.styleText]);
        }
      },
      '&:hover, &:focus': {
        background: function background(props) {
          return "".concat(theme.palette[props.styleType][props.styleVariant]);
        },
        color: function color(props) {
          return "".concat(theme.palette[props.styleType][props.styleText]);
        },
        opacity: '0.8'
      }
    }
  };
}); // Clean way to expose our custom variants

var ChipWrapper = function ChipWrapper(_ref) {
  var customColor = _ref.customColor,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["customColor", "variant"]);

  if (customColor) {
    // Build text style based on customColor sent
    var styleType = customColor.split('.')[0];
    var styleVariant = customColor.split('.')[1];
    var customProps = {
      styleType: styleType,
      styleVariant: styleVariant,
      styleText: "".concat(styleVariant, "Text")
    };
    var classes = variant && variant === 'outlined' ? outLinedCustomChip(customProps) : filledCustomChip(customProps);
    return _react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
      variant: variant
    }, props, {
      className: classes.root
    }));
  }

  return _react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
    variant: variant
  }, props));
};

ChipWrapper.propTypes = {
  customColor: _propTypes["default"].string,
  variant: _propTypes["default"].string
};
var _default = ChipWrapper;
exports["default"] = _default;